import React from 'react'
import IphoneImage from '../../assets/image/Iphone.png'
import FeatureList from './pagecomponents/FeatureList'
import SavingGrowth from './pagecomponents/SavingGrowth'
import StatsCard from './pagecomponents/StatsCard'

const WeHelpClients = () => {
  return (
    <div className='bg-white py-28'>
        <div className="container px-4 max-w-8xl mx-auto grid lg:grid-cols-2 gap-16 items-center m-auto">
            <div className="relative m-auto"> 
                <SavingGrowth />
                <div className="relative mb-4">
                    <img src={IphoneImage} alt="" className='lg:h-[500px] md:h-[500px] sm:h-[450px] h-[450px] w-full object-contain' />
                </div>
                <StatsCard />
            </div>
            <div className="relative">
                <div className="relative">
                    <div className='mb-5'>
                        <h1 className="text-4xl lg:text-6xl font-bold text-[#6540b2] mb-6">
                        Revolutionizing Payments: Empowering Users and Businesses
                        </h1>
                        <p className="text-gray-600 text-lg">
                        Our cutting-edge crypto payment system app, complete with an integrated crypto wallet and a physical card, bridges the gap between digital and real-world spending. It’s designed to deliver transformative benefits for both individuals and shopkeepers, making financial interactions more inclusive, efficient, and rewarding.
                        </p>
                    </div>
                    <FeatureList />
                </div>
            </div>
        </div>
    </div>
  )
}

export default WeHelpClients